<template>
    <div class="timeout-content-shift">
        <v-card
            v-for="row in rows"
            :key="row.key"
            color="black"
            class="timeout-row rounded-lg px-10 py-5 white--text"
            :style="`box-shadow: inset 30px 0 0 0 ${row.color};`"
        >
            <div class="media-row">
                <img
                    :src="`${assetsUrl}/${row.team?.logo}`"
                    width="150px"
                    height="auto"
                    class="pl-5"
                >
                <span class="timeout-team-name">{{ row.team.name }}</span>
                <span
                    v-for="period in periods"
                    :key="`${row.key}-period-${period}`"
                    class="timeout-period"
                    :style="{
                        color: ((Number(row.periodScores[period]) || 0) > (Number(row.opponentPeriodScores[period]) || 0)) ? '#00f3b3' : ''
                    }"
                >
                    {{ row.periodScores[period] ?? '-' }}
                </span>
                <span
                    class="timeout-total"
                    :class="(Number(row.score) || 0) > (Number(row.opponentScore) || 0) ? 'custom-orange-text' : 'white--text'"
                >
                    {{ row.score ?? 0 }}
                </span>
            </div>
        </v-card>
    </div>
</template>

<script>
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    export default {
        name: 'TimeOut',
        props: {
            match: {
                type: Object,
                default: () => ({ team1: {}, team2: {} })
            },
            periodScoresTeam1: {
                type: Object,
                default: () => ({})
            },
            periodScoresTeam2: {
                type: Object,
                default: () => ({})
            },
            periods: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            rows() {
                // team colours that show on the black rows and differ from each other
                const colors = getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.black)
                return [
                    {
                        key: 'team1',
                        team: this.match.team1 || {},
                        color: colors.team1,
                        periodScores: this.periodScoresTeam1,
                        opponentPeriodScores: this.periodScoresTeam2,
                        score: this.match.team1Score,
                        opponentScore: this.match.team2Score
                    },
                    {
                        key: 'team2',
                        team: this.match.team2 || {},
                        color: colors.team2,
                        periodScores: this.periodScoresTeam2,
                        opponentPeriodScores: this.periodScoresTeam1,
                        score: this.match.team2Score,
                        opponentScore: this.match.team1Score
                    }
                ]
            }
        }
    }
</script>

<style scoped>
/* Both rows stretch to the wider one, so the period columns line up */
.timeout-content-shift {
    display: inline-flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;

    /* Centre the card in the space right of the match info header (which ends ~605px from the left) */
    transform: translateX(calc(2.5vw + 302px));
}

@media (max-width: 960px) {
    .timeout-content-shift {
        transform: translateX(3%);
    }
}

.timeout-row {
    min-width: 1000px;
}

.media-row {
    display: flex;
    align-items: center;        /* vertical center */
    justify-content: flex-start;/* horizontal start (left) */
    gap: 12px;                  /* space between image and text */
}

/* Full team name on one line; the card grows to fit it */
.timeout-team-name {
    flex: 1 0 auto;
    min-width: 300px;
    padding-right: 20px;
    white-space: nowrap;
}

.timeout-period {
    flex: 0 0 90px;
    text-align: center;
    font-size: 55px;
    font-weight: bold;
}

.timeout-total {
    flex: 0 0 150px;
    text-align: right;
    font-size: 75px;
    font-weight: bold;
}
</style>
